import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, Home } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const PayPalCancel = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      cancelled: 'Paiement PayPal annulé',
      message: 'Votre paiement PayPal a été annulé. Aucun montant n\'a été débité.',
      info: 'Si vous avez rencontré un problème avec PayPal, n\'hésitez pas à nous contacter ou à réessayer avec une autre méthode de paiement.',
      tryAgain: 'Réessayer',
      backHome: 'Retour à l\'accueil',
      contactUs: 'Nous contacter'
    },
    en: {
      cancelled: 'PayPal payment cancelled',
      message: 'Your PayPal payment has been cancelled. No amount has been charged.',
      info: 'If you encountered a problem with PayPal, feel free to contact us or try again with another payment method.',
      tryAgain: 'Try again',
      backHome: 'Back to home',
      contactUs: 'Contact us'
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl shadow-2xl">
        <CardContent className="p-12">
          <div className="text-center mb-8">
            <div className="bg-orange-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="h-12 w-12 text-orange-600" />
            </div>
            <h1 className="text-3xl font-bold text-slate-900 mb-2">{t.cancelled}</h1>
            <p className="text-lg text-slate-600">{t.message}</p>
          </div>

          <div className="bg-slate-50 p-6 rounded-lg mb-8">
            <p className="text-slate-700 text-center">{t.info}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild className="bg-blue-900 hover:bg-blue-800">
              <Link to="/payment">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t.tryAgain}
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                {t.backHome}
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/contact">
                {t.contactUs}
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PayPalCancel;
